import Axios, { AxiosResponse, Method } from 'axios';
import { getSessionStorageItem } from './storage';

function authRequestInterceptor(config: any) {
  config.headers = config.headers ?? {};
  const token: string | null = getSessionStorageItem('token');
  if (token !== null && token !== undefined) {
    config.headers.authorization = `Bearer ${token}`;
  }
  config.headers.Accept = 'application/json';
  return config;
}
export const axios = Axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL}/`,
});
axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    // return response.data?.result ? response.data?.result : response.data;
    return typeof response.data?.result !== 'undefined' && response.data?.result !== null
      ? response.data?.result
      : response.data;
  },
  (error: any) => {
    // let message = error.response?.data?.message || error.message;
    let message = error.response?.data?.message ?? error.message;
    if (
      error.response !== undefined &&
      error.response !== null &&
      error.response.data !== undefined &&
      error.response.data !== null &&
      error.response.data.error !== undefined &&
      error.response.data.error !== null &&
      ((error.response.data.error.errors !== undefined &&
        error.response.data.error.errors !== null &&
        Array.isArray(error.response.data.error.errors)) ||
        (error.response.data.error.error_params !== undefined &&
          error.response.data.error.error_params !== null &&
          Array.isArray(error.response.data.error.error_params)))
    ) {
      const errors = error.response.data.error.errors;
      const errorParams = error.response.data.error.error_params;

      if (errors !== undefined && errors !== null && Array.isArray(errors)) {
        message = errors.join(',');
      } else if (errorParams !== undefined && errorParams !== null && Array.isArray(errorParams)) {
        message = errorParams
          .map((e: any) => (e.message !== undefined && e.message !== null ? e.message : e.msg))
          .filter((item) => item !== undefined && item !== null)
          .join(',');
      }
    }

    // Handle Error

    return Promise.reject({
      statusCode: error.response?.status,
      message: message,
    });
  },
);

// Common method for api hitting

async function apiCall<T = any>(method: Method, url: string, data?: any, config?: any): Promise<AxiosResponse<T>> {
  // Return type is now AxiosResponse<T>
  try {
    const response: AxiosResponse<T> = await axios({
      method,
      url,
      data,
      ...config,
      // You can add headers or other configurations here if needed
    });
    return response; // Return the whole response object
  } catch (error: any) {
    console.error('API call error:', error); // Log the error for debugging
    throw error; // Rethrow the error for handling in the caller
  }
}

export default apiCall;
